<template>
  <v-row dense no-gutters :justify="actionJustify">
    <v-btn :class="btnClass" @click="modalProducts=true" text color="primary" :ripple="false"><v-icon v-if="btnIcon" left>{{btnIcon}}</v-icon>{{btnText}}</v-btn>

    <!-- products dialog -->
    <v-dialog v-model="modalProducts" width="600" persistent scrollable no-click-animation>
      <v-card class="pa-0">
        <v-card-title class="pa-0">
          <v-toolbar color="transparent" flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
              <span v-if="!productSelected.id">Seleccionar un producto</span>
              <template v-else>
                <a v-if="productSelected.id" @click="productSelected={}">{{productSelected.name}}</a>
                <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
                <span>Seleccionar plan</span>
              </template>
            </v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="pr-1">
                <v-btn class="ml-3" @click="modalProducts=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="text-left" v-if="!productSelected.id">
              <v-col class="pt-2 pb-1">
                <v-text-field background-color="white" outlined required single-line class="pa-0 mb-1" dense v-model="productQuery" placeholder="Escribe para buscar un producto..." hide-details />
              </v-col>
              <v-col v-if="currency" class="pa-0">
                <v-divider/>
                <p class="my-2 pl-3">Sólo se muestran productos en moneda <b> {{currency.id}}</b></p>
              </v-col>
              <v-divider/>
              <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="list-item"/>
              <template v-else>
                <template v-if="productsList.length">
                  <v-simple-table id="it-subscription-set_product">
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in productsList" :key="d.id" @click="productSelected=d" style="cursor: pointer">
                          <td class="pt-3">
                            <div class="d-flex">
                              <span class="body-1 text--secondary font-weight-medium">{{d.name}}</span>
                              <v-spacer/>
                              <v-icon color="secondary">mdi-chevron-right</v-icon>
                            </div>
                            <p>{{d.plans.length}} planes de precios</p>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col class="text-center py-8" v-else>
                  <div class="text-center mb-4">
                    <v-icon size="70" color="secondary">mdi-close</v-icon>
                  </div>
                  <span class="subtitle-1 text-center font-weight-regular">No existen productos</span>
                </v-col>
              </template>
            </v-col>
            <v-col cols="12" v-else>
              <v-col class="py-0" v-if="currency" style="border-bottom: 1px solid #D8E0EA !important;">
                <p class="my-2 pl-1">Sólo se muestran productos en moneda <b>{{currency.id}}</b></p>
              </v-col>
              <v-simple-table id="it-subscription-set_plan">
                <template v-slot:default>
                  <tbody>
                    <tr v-for="d in productSelected.plans" :key="d.id" style="cursor: pointer">
                      <td class="py-3" v-if="(!currency || currency.id === d.currency.id) && (!frequency || frequency === d.frequency.id)" @click="setPlan(d)">
                        <div class="d-flex">
                          <span class="body-1 text--secondary font-weight-medium">{{d.name}}</span>
                          <template v-if="checkPlanIsAdded(d.id)">
                            <v-spacer/>
                            <v-chip color="defaultGrey" text-color="secondary" small>Añadido<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
                          </template>
                        </div>
                        <div>
                          <template v-if="d.tiers_mode">desde {{d.tiers[0].amount | currency(d.currency.id)}}</template>
                          <template v-else>{{d.amount | currency(d.currency.id)}}</template>
                          {{d.currency.id}} {{d.frequency.name.toLowerCase()}}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end products dialog -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  props: {
    actionJustify: {
      type: String,
      required: false,
      default: () => ('start')
    },
    btnClass: {
      type: String,
      required: false,
      default: () => ('')
    },
    btnIcon: {
      type: String,
      required: false,
      default: () => ('mdi-plus')
    },
    btnText: {
      type: String,
      required: false,
      default: () => ('Agregar plan')
    },
    currency: {
      type: Object,
      required: false,
      default () {
        return null
      }
    },
    frequency: {
      type: String,
      required: false,
      default () {
        return null
      }
    },
    selectedItems: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    extraQuery: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    productQuery: '',
    productSelected: {},
    modalProducts: false
  }),
  computed: mapState({
    productsList: state => state.subscriptions.productsList
  }),
  watch: {
    productQuery () {
      this.debounceMethod(this.getProducts)
    },
    modalProducts () {
      if (this.modalProducts) {
        this.getProducts()
      }
    }
  },
  methods: {
    getProducts () {
      if ([1, 2].includes(this.productQuery.length)) {
        return false
      }
      const query = {
        page_size: 10
      }
      if (this.productQuery.length >= 3) {
        query.name__icontains = this.productQuery.toLowerCase()
      }
      if (this.currency) {
        query.plans__currency = this.currency.id
      }
      if (this.frequency) {
        query.plans__frequency = this.frequency
      }
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'products',
        query: Object.assign({}, query, this.extraQuery)
      })
    },
    setPlan (plan) {
      if (this.checkPlanIsAdded(plan.id)) {
        return false
      }
      this.productQuery = ''
      this.productSelected = {}
      this.modalProducts = false
      this.$emit('selected', plan)
    },
    checkPlanIsAdded (id) {
      const plan = this.selectedItems.filter(p => p === id)
      if (plan.length) {
        return true
      }
      return false
    }
  }
}
</script>